import { keymap } from "prosemirror-keymap";
import {Plugin, Command, EditorState, Transaction, TextSelection} from "prosemirror-state";
import {undo, redo} from "prosemirror-history";
import {canSplit} from "prosemirror-transform";
import {chainCommands, deleteSelection, joinBackward, joinForward, selectNodeForward, selectNodeBackward,
	newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock, exitCode, selectAll, selectTextblockStart, selectTextblockEnd } from "prosemirror-commands";
import {enterKeyInDList, enterKeyInListItem} from "@fd/editors/html/commands/Lists.ts";
import {enterKeyInBlockquote} from "@fd/editors/html/commands/Blockquote.ts";
import {insertHardBreak} from "@fd/editors/html/commands/HardBreak.ts";
import {EditorView} from "prosemirror-view";

const mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform)
	// @ts-ignore
	: typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;


let backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
let del = chainCommands(deleteSelection, joinForward, selectNodeForward);
let enter = chainCommands(newlineInCode, enterKeyInDList, enterKeyInBlockquote, enterKeyInListItem, createParagraphNear, liftEmptyBlock, splitBlock);
let secondaryEnter = chainCommands(exitCode, insertHardBreak);
const insertHardSpace:Command = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView):boolean => {
	const { $from } = state.selection;
	const textNode = state.schema.text('\u00A0');
	if (dispatch) {
		dispatch(state.tr.insert($from.pos, textNode).scrollIntoView());
	}
	return true;
}

let debugCommand:Command = (state, dispatch?) => {
	// Print cursor info
	return false;
};

export const pcBaseKeymap: {[key: string]: Command} = {
	"Enter": enter,
	"Mod-Enter": secondaryEnter,
	"Shift-Enter": secondaryEnter,
	"Ctrl-Shift-Enter":debugCommand,
	"Ctrl-Shift-Space": insertHardSpace,
	"Backspace": backspace,
	"Mod-Backspace": backspace,
	"Shift-Backspace": backspace,
	"Delete": del,
	"Mod-Delete": del,
	"Mod-a": selectAll
};

export const macBaseKeymap: {[key: string]: Command} = {
	"Ctrl-h": pcBaseKeymap["Backspace"],
	"Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
	"Ctrl-d": pcBaseKeymap["Delete"],
	"Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
	"Alt-Delete": pcBaseKeymap["Mod-Delete"],
	"Alt-d": pcBaseKeymap["Mod-Delete"],
	"Ctrl-a": selectTextblockStart,
	"Ctrl-e": selectTextblockEnd,
	...pcBaseKeymap
};

export const baseKeymap: {[key: string]: Command} = mac ? macBaseKeymap : pcBaseKeymap;

/** DEBUG COMMAND utility */
export function dc(c:Command, name:string=null) {
	return (state: EditorState, dispatch?: (tr: Transaction) => void) => {
		debugger;
		const exit = c(state, dispatch);
		if (name) console.log("Command " + name + " exited with " + exit);
		return exit;
	};
}

export function keyboardSupport(c:{ [key:string]:Command } = {}):Plugin[] {

	const keyBindings:{[key: string]: Command} = {
		'Mod-b': c.bold,
		'Mod-i': c.italic,
		'Mod-u': c.underline,
		"Mod-z": undo,
		"Mod-y": redo,
		"Tab": chainCommands(c.nextCell, c.indent),
		"Shift-Tab": chainCommands(c.prevCell, c.outdent),
	};

	const plugins:Plugin[] = [
		keymap(keyBindings),
		keymap(baseKeymap)
	];
	return plugins;
}